import { PaymentSessionType } from '@monorepo/types';
import BaseEntityService, { BaseResponse } from '../core/base-entity-service';

export default class PaymentSessionService extends BaseEntityService {
  static override route = 'payment-session';

  async getPaymentSession(sessionId: string) {
    try {
      const response = await this.httpService.get<
        BaseResponse<PaymentSessionType>
      >(`${this.path}/${sessionId}`);

      return response.data;
    } catch (error) {
      console.error(`Failed getting payment session ${sessionId}`, error);
      throw error;
    }
  }

  async confirmPaymentHandleToken(
    paymentHandleToken: string,
    sessionId: string,
  ) {
    try {
      const response = await this.httpService.post<
        { paymentHandleToken: string; sessionId: string },
        BaseResponse<{ redirectUrl: string }>
      >(`${this.path}/confirm-payment-handle-token`, {
        paymentHandleToken,
        sessionId,
      });

      return response.data;
    } catch (error) {
      console.error(
        `Failed confirming payment handle token ${paymentHandleToken} for session ${sessionId}`,
        error,
      );
      throw error;
    }
  }

  async claimPaymentSession(sessionId: string) {
    try {
      const response = await this.httpService.post<
        Record<string, never>,
        BaseResponse<PaymentSessionType>
      >(`${this.path}/${sessionId}/claim`, {});

      return response.data;
    } catch (error) {
      console.error(`Failed claiming payment session ${sessionId}`, error);
      throw error;
    }
  }
}
